import Documentation from './views/Documentation.vue'

const route = [
  {
    path: '/documentation',
    name: 'documentation',
    component: Documentation,
    meta: {
      layout: 'default',
      auth: true,
      menu: true,
      title: 'Documentation',
      lang_code: 'documentation',
      role: ['A','R','C','I'],
      order: 10
    }
  }
]

export default route
